import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Button, Input } from "reactstrap";
import HoverImage from "react-hover-image/build";

import API from "utils/API";
import Drawer from "components/Drawer";
import commonColumns from "utils/columns";
import ErrorBoundary from "components/ErrorBoundary";
import AttachIcon from "assets/icon/icon-icon-options-attachment.svg";
import AttachHoverIcon from "assets/icon/icon-icon-options-attachment_hover.svg";
import ReactStrapTable from "components/reactStrapTable";
import Comments from "../../common/Comments";
import FaxIcon from "assets/icon/fax-blue.svg";
import Fax from "../../common/Fax";

let chckedIds = [];
let rxNumbers = [];

const PatientDetailsTable = (props) => {
  let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: "",
    order: "",
    filters: [],
  };
  const { onClaimSelect, handleLoading, onRxSelect, refresh } = props;
  const { patientId, tenantID } = useParams();
  const [isOpen, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [claim, setClaim] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [initFilter, setInitFilter] = useState(initialFilters);

  const fetchPatientDetails = async (filters = {}, hasFilter) => {
    handleLoading(true);
    let pageFilter = { ...filters };
    if (hasFilter) {
      pageFilter.filters = [...initialFilters.filters, ...filters.filters];
      initialFilters.filters = filters.filters;
    } else {
      initialFilters = { ...initialFilters, ...filters };
    }
    try {
      const { data } = await API.post(
        `/${tenantID}/Claim/PatientClaims/${parseInt(patientId)}`,
        pageFilter
      );
      if (data) {
        handleLoading(false);
        setData(data.items);
        setTotalSize(data.totalRecords);
      }
    } catch (error) {
      handleLoading(false);
    }
  };

  useEffect(() => {
    chckedIds = [];
    rxNumbers = [];
    fetchPatientDetails({
      currentPage: 1,
      pageSize: 10,
      orderBy: "",
      order: "",
      filters: [],
    });
  }, [refresh]);

  const toggleDrawer = (claim = {}) => {
    setClaim(claim);
    setOpen(!isOpen);
  };

  const toggleDrawerFax = (claim = {}) => {
    setClaim(claim);
    setOpen(!isOpen);
  };

  const onChange = (claim) => {
    const { claimID, rxNumber } = claim;
    const index = chckedIds.indexOf(claimID);
    const index2 = rxNumbers.indexOf(rxNumber);
    if (chckedIds.length === 0) {
      chckedIds.push(claimID);
      rxNumbers.push(rxNumber);
    } else {
      if (index >= 0) {
        chckedIds.splice(index, 1);
        rxNumbers.splice(index2, 1);
      } else {
        chckedIds.push(claimID);
        rxNumbers.push(rxNumber);
      }
    }
    setSelectedIds([...chckedIds]);
    onClaimSelect([...chckedIds]);
    onRxSelect([...rxNumbers]);
  };

  const attachFile = (claim) => {
    const filter = selectedIds.filter((item) => item === claim.claimID);
    return (
      <div className="d-flex align-items-center">
        <Input
          onChange={() => onChange(claim)}
          type="checkbox"
          className="me-2 mt-0"
          value={filter.length > 0}
          checked={filter.length > 0}
        />
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleDrawer(claim)}
        >
          <HoverImage src={AttachIcon} hoverSrc={AttachHoverIcon} alt="" />
        </Button>
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleDrawerFax(claim)}
        >
          <img src={FaxIcon} alt="" className="me-2" />
        </Button>
      </div>
    );
  };

  const columns = [
    {
      dataField: "attachement",
      text: "Options",
      cellRenderer: (rowData) => attachFile(rowData),
      width: 120,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    ...commonColumns,
  ];

  const handlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setInitFilter(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      fetchPatientDetails(colFilterOn, true);
    } else {
      setInitFilter(filter);
      fetchPatientDetails(filter);
    }
  };

  const handleSort = (filter, hasColFilter) => {
    setInitFilter(filter);
    if (hasColFilter) {
      fetchPatientDetails(filter, true);
    } else {
      fetchPatientDetails(filter);
    }
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      handleLoading(true);
      setInitFilter(filter);
      fetchPatientDetails(filter, true);
    }
  };

  const handleFilterCancel = () => {
    initialFilters.filters = [];
    handleLoading(true);
    setInitFilter(initialFilters);
    fetchPatientDetails(initialFilters);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setInitFilter(filter);
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return fetchPatientDetails(colFilterOn, true);
    }
    setInitFilter(filter);
    fetchPatientDetails(filter);
  };

  return (
    <div className="pt-2">
      <div
        className="table-card filter-table position-relative border-0"
        fixed-height={data.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="patient-details-table"
          fixedColumn
          height={50 * 5}
          width={1200}
          columns={columns}
          data={data}
          handleSort={handleSort}
          loader
          filters={initFilter}
          onSearchColumnFilters={handleSearchColumnFilters}
          onFilterCancel={handleFilterCancel}
          hasPagination
          pageSize={initFilter.pageSize}
          onPageSizeChange={onPageSizeChange}
          currentPage={initFilter.currentPage}
          totalRecords={totalSize}
          onPageChange={handlePageChange}
        />
      </div>
      <Drawer
        direction="end"
        isOpen={isOpen}
        toggle={toggleDrawer}
        title="Add Claim Comment"
      >
        <ErrorBoundary>
          <Comments rxNumber={claim?.rxNumber} onClose={toggleDrawer} />
        </ErrorBoundary>
      </Drawer>
      <Drawer
        direction="end"
        isOpen={isOpen}
        toggle={toggleDrawerFax}
        title="Send Fax"
      >
        <ErrorBoundary>
          <Fax claim={claim} onClose={toggleDrawerFax} />
        </ErrorBoundary>
      </Drawer>
    </div>
  );
};

export default PatientDetailsTable;
